// https://gist.github.com/james2doyle/4aba55c22f084800c199

import Vue from 'vue';
import {Formatters} from '@/utils/Formatters';

// usage: {{ file.size | prettyBytes }}
Vue.filter('prettyBytes', Formatters.Bytes);
